import {
  Box,
  Button,
  Divider,
  Heading,
  HStack,
  Text,
  VStack,
} from '@chakra-ui/react';
import { FC } from 'react';

export interface WaitingParticipant {
  id: string;
  name: string;
}

export interface WaitingRoomPopupUIProps {
  participants: WaitingParticipant[];
  grantAccess: (id: string) => void;
  denyAccess: (id: string) => void;
}

export const WaitingRoomPopupUI: FC<WaitingRoomPopupUIProps> = ({
  participants,
  grantAccess,
  denyAccess,
}) => {
  const handleAdmitAll = () => {
    participants.forEach((p) => grantAccess(p.id));
  };

  return (
    <Box
      position="fixed"
      p={4}
      top={4}
      right={4}
      zIndex={1500}
      w="400px"
      data-testid="waiting-room-popup"
    >
      <Box
        bg="surface.default"
        borderRadius={10}
        borderWidth={1}
        borderColor="border.default"
        boxShadow="lg"
        p={4}
        overflow="hidden"
      >
        <Box px={5} pt={4} pb={4}>
          <HStack justify="space-between" align="start">
            <Box>
              <Heading
                size="md"
                fontFamily="Plus Jakarta Sans"
                color="text.default"
              >
                Waiting room
              </Heading>
              <Text fontSize="sm" color="text.muted" mt={1}>
                {participants.length} participant
                {participants.length !== 1 ? 's' : ''} waiting to join
              </Text>
            </Box>
            {participants.length > 1 && (
              <Button
                size="sm"
                colorScheme="green"
                onClick={handleAdmitAll}
                data-testid="admit-all"
                flexShrink={0}
              >
                Admit all
              </Button>
            )}
          </HStack>
        </Box>

        <Divider borderColor="border.default" />

        <VStack spacing={0} align="stretch">
          {participants.map((participant, index) => (
            <Box key={participant.id}>
              {index > 0 && <Divider borderColor="border.default" />}
              <HStack justify="space-between" px={5} py={3}>
                <Text
                  fontWeight="medium"
                  noOfLines={1}
                  flex={1}
                  color="text.default"
                >
                  {participant.name || 'Unknown'}
                </Text>
                <HStack spacing={3}>
                  <Button
                    size="sm"
                    variant="ghost"
                    color="text.muted"
                    onClick={() => denyAccess(participant.id)}
                    data-testid={`deny-${participant.id}`}
                  >
                    Deny
                  </Button>
                  <Button
                    size="sm"
                    onClick={() => grantAccess(participant.id)}
                    data-testid={`admit-${participant.id}`}
                    variant={participants.length > 1 ? 'outline' : undefined}
                  >
                    Admit
                  </Button>
                </HStack>
              </HStack>
            </Box>
          ))}
        </VStack>
      </Box>
    </Box>
  );
};
